import styles from "./GlobalSearch.module.css";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { SocietyDTO } from "../../context/SocietyProvider";
import SocietySearchBar from "./SocietySearchBar";

interface GlobalSearchProps {
    societies: SocietyDTO[],
}

const GlobalSearch = ({ societies }: GlobalSearchProps) => {

    return (
        <Box
            sx={{
                backgroundColor: "primary.main",
                minHeight: "500px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }}
        >
            <div className={styles.content}>
                <Box
                    component="img"
                    sx={{ width: { xs: 200, sm: 250 } }}
                    src={'/looty-logo.png'}
                    alt="looty logo"
                />

                <Typography
                    sx={{
                        color: '#ffffff',
                        fontSize: { xs: 20, sm: 35 },
                        mt: 4,
                        mb: 4,
                    }}
                    variant={"firstVariant"}
                >
                    Découvre nos membres qui se sont inscrits.
                </Typography>

                <SocietySearchBar societies={societies ? societies : []} />

            </div>
        </Box>
    );
}

export default GlobalSearch